(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('bookingTracker', function(bookingService) {
    //booking may be on an ancester scope
    function findBooking(s) {
        if (s.cm) {
            if (s.cm.booking) {
                return s.cm.booking;
            }
        }
        return s.$parent ? findBooking(s.$parent) : null;
    }

    return {
        restrict: 'A',
        require: '?ngModel',
        link(scope, el, attr, c) {
            const update = _.debounce(function() {
                const b = findBooking(scope);
                if (b) {
                    bookingService.updateBooking(b, `${attr.bookingDescription} changed to: ${c.$modelValue}`);
                }
            }, 1000);

            if (c != null) {
                c.$viewChangeListeners.push(update);
                c.$updateBooking = update;
            } else {
                const bw = scope.$watch('cm.booking', function(b, oldB) {
                    if (b != null && !angular.equals(b, oldB)) {
                        bw();
                        return;
                    }
                    scope.$watch(attr.bookingTracker, _.debounce(function(val, prev) {
                        if (!angular.equals(val, prev) && !!b) {
                            bookingService.updateBooking(scope.cm.booking, `${attr.bookingDescription} changed to: ${val}`);
                        }
                    }, 1000), true);
                }, true);
            }
        }
    };
});
})();
